// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HjiC","col":"styles_col__25zXz"};